import { replaceVariablesWithContent } from '../../utils/string';
import { formatPriceToReal } from '../utils/formatters';

type UseFipeRules = {
  maxPrice: number;
  minPrice: number;
  priceMinErrorMessage: string;
  priceMaxErrorMessage: string;
  isMaxActive: boolean;
  isMinActive: boolean;
};

export function useFipeRules(
  averagePrices:
    | {
        iCarros: number;
        fipe: number;
      }
    | undefined,
  priceRules:
    | {
        value: string;
      }
    | undefined
): UseFipeRules | undefined {
  if (!priceRules) return;
  if (!averagePrices) return;

  const fipePrice = averagePrices.fipe;
  const priceRulesValues = priceRules && JSON.parse(priceRules.value);
  const fipeMaximum = priceRulesValues.maximo;
  const fipeMinimum = priceRulesValues.minimo;

  const maxPrice = fipePrice ? fipePrice + (fipePrice * fipeMaximum.percentual) / 100 : 0;
  const minPrice = fipePrice ? fipePrice - (fipePrice * fipeMinimum.percentual) / 100 : 0;

  const isMaxActive = fipeMaximum.ativo;
  const isMinActive = fipeMinimum.ativo;

  const priceMaxErrorMessage = replaceVariablesWithContent(
    fipeMaximum.mensagem,
    ['#{valorMaximo}', '#{porcentagemAcima}'],
    [formatPriceToReal(maxPrice), `${fipeMaximum.percentual}%`]
  );

  const priceMinErrorMessage = replaceVariablesWithContent(
    fipeMinimum.mensagem,
    ['#{valorMinimo}', '#{porcentagemAbaixo}'],
    [formatPriceToReal(minPrice), `${fipeMinimum.percentual}%`]
  );

  return {
    maxPrice,
    minPrice,
    priceMaxErrorMessage,
    priceMinErrorMessage,
    isMaxActive,
    isMinActive
  };
}
